'use client';

import { FC, useState } from 'react';
import { Button, Card, Flex, Icon, Text } from '@/_components';
import { ImportOptionsSectionProps } from './ImportOptionsSection.types';
import styles from './ImportOptionsSection.module.css';

export const ImportOptionsSection: FC<ImportOptionsSectionProps> = ({
  onSelectPath,
}) => {
  const [selectedOption, setSelectedOption] = useState<'manual' | null>(null);

  const handleAutomaticClick = () => {
    onSelectPath();
  };

  const handleManualClick = () => {
    setSelectedOption('manual');
  };

  const handleBackToOptions = () => {
    setSelectedOption(null);
  };

  if (selectedOption === 'manual') {
    return (
      <Flex isColumn gap={4} className={styles.sectionWrapper}>
        <Button
          value="Back to import options"
          intent="ghost"
          size="small"
          iconLeft="arrow-left"
          onClick={handleBackToOptions}
        />
      </Flex>
    );
  }

  return (
    <Flex isColumn gap={6} className={styles.sectionWrapper}>
      <Text fontWeight="semi-bold" textAlign="center">
        Choose how you&apos;d like to import your individuals:
      </Text>

      <Flex gap={4} xAlign="center">
        <Card
          className={`${styles.optionCard} ${styles.optionCardAutomatic}`}
          onClick={handleAutomaticClick}
        >
          <Flex gap={4} isColumn isCentered className={styles.optionContent}>
            <Icon
              name="gear-fine"
              size={32}
              color="primary"
              className={styles.optionIcon}
            />
            <Text
              fontWeight="semi-bold"
              textAlign="center"
              className={styles.optionTitle}
            >
              Automatic Import
            </Text>
            <Text color="secondary" type="small" textAlign="center">
              Import individuals yourself quickly using our new, automatic
              import process
            </Text>
            <Button
              value="Get started"
              intent="primary"
              size="small"
              iconRight="arrow-right"
              className={styles.optionButton}
            />
          </Flex>
        </Card>

        <Card
          className={`${styles.optionCard} ${styles.optionCardManual}`}
          onClick={handleManualClick}
        >
          <Flex gap={4} isColumn isCentered className={styles.optionContent}>
            <Icon
              name="users"
              size={32}
              color="secondary"
              className={styles.optionIcon}
            />
            <Text
              fontWeight="semi-bold"
              textAlign="center"
              className={styles.optionTitle}
            >
              Soraban Import Service
            </Text>
            <Text color="secondary" type="small" textAlign="center">
              Have Soraban&apos;s team import your client list for you (7-10
              business days)
            </Text>
            <Button
              value="Select this option"
              intent="ghost"
              size="small"
              iconRight="arrow-down"
              className={styles.optionButton}
            />
          </Flex>
        </Card>
      </Flex>
    </Flex>
  );
};
